// extracted by mini-css-extract-plugin
export default {"col":"index_col_Qp4hV","mt50":"index_mt50_rpeYK","mt36":"index_mt36_C4SQf","mt33":"index_mt33_pUYnV"};